<div *transloco="let t" class="flex flex-col overflow-hidden lg:h-available p-4 lg:p-12 gap-8">

  <!-- Header -->
  <div class="flex flex-col gap-1">
    <div class="font-thin text-3xl">{{ t('profile.soldedArtworks.title') }}</div>
    @if (!sales.isLoading() && soldArtworks.length > 0) {
      <div class="text-gray-500 text-sm">
        {{ soldArtworks.length }} {{ soldArtworks.length === 1 ? t('profile.soldedArtworks.soldOne') : t('profile.soldedArtworks.soldMany') }} &middot;
        {{ t('profile.soldedArtworks.totalEarned') }}:&nbsp;<span class="font-semibold text-black">{{ totalEarned() | currency : 'EUR' : '' : '1.2-2' }} €</span>
      </div>
    }
  </div>

  @if (sales.isLoading()) {
    <div class="flex items-center justify-center h-64 text-gray-400 text-lg font-thin">{{ t('profile.soldedArtworks.loading') }}</div>
  } @else if (soldArtworks.length === 0) {
    <div class="flex flex-col items-center justify-center h-64 gap-4 text-gray-400">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="w-16 h-16 opacity-30">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z" />
      </svg>
      <span class="font-thin text-xl">{{ t('profile.soldedArtworks.empty') }}</span>
    </div>
  } @else {
    <div class="flex flex-col gap-6">
      @for (artwork of soldArtworks; track artwork.id) {
        <div class="flex flex-col sm:flex-row gap-6 rounded-2xl border border-gray-100 bg-white shadow-sm p-4 hover:shadow-md transition-shadow duration-300">

          <!-- Immagine -->
          <a [routerLink]="['/artworks', artwork.id]" class="shrink-0 w-full sm:w-36 h-36 overflow-hidden rounded-xl bg-gray-50 flex items-center justify-center">
            @if (artwork.mainAttachment) {
              <img [src]="artwork.mainAttachment.url" class="w-full h-full object-cover" />
            } @else {
              <div class="text-gray-300 text-sm">{{ t('profile.soldedArtworks.noImage') }}</div>
            }
          </a>

          <!-- Info opera -->
          <div class="flex flex-col justify-between flex-1 gap-3">
            <div>
              <a [routerLink]="['/artworks', artwork.id]" class="text-xl font-light hover:underline">{{ artwork.name }}</a>
              <div class="text-gray-400 text-sm mt-0.5">{{ artwork.year }} &middot; {{ artwork.technique }}</div>
            </div>

            <!-- Ordini collegati -->
            <div class="flex flex-col gap-2">
              @for (row of artwork.orderRows; track row.id) {
                <div class="flex flex-wrap items-center justify-between gap-2 rounded-xl bg-gray-50 px-4 py-3">
                  <div class="flex items-center gap-3">
                    <span class="text-xs font-semibold px-2 py-1 rounded-full" [class]="statusClass(row.order.status)">
                      {{ t('orders.status.' + row.order.status) }}
                    </span>
                    <span class="text-gray-400 text-sm">{{ row.order.createdAt | date : 'dd MMM yyyy' }}</span>
                    <span class="text-sm text-gray-500">{{ t('profile.soldedArtworks.qty') }}: {{ row.qty }}</span>
                  </div>
                  <div class="font-semibold text-lg">
                    {{ (row.price * row.qty) | currency : 'EUR' : '' : '1.2-2' }} €
                  </div>
                </div>
              }
            </div>
          </div>

        </div>
      }
    </div>
  }

</div>
